import { mutatorAction } from 'satcheljs';
import { ServiceCallLog } from '../store/schema/FormsDiagnosticsStore';
import getStore from '../store/store';

export default mutatorAction('insertServiceCallMutator', function insertServiceCallMutator(
    serviceCall: ServiceCallLog
) {
    getStore().serviceCalls.push(serviceCall);
});
